<div class="card custom-card">
    <div class="card-header">
        Event
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-1" *ngIf="event.status === 1">
                                <button type="button" class="btn btn-danger btn-sm btn-block" (click)="denyEventClick()">Deny
                  Event</button>
                            </div>
                            <div class="col-2">
                                <a href="events/delivery-paper/{{event.id}}" target="_blank" class="btn btn-light btn-sm btn-block"><i
                    class="fa fa-print"></i>Delivery
                  paper</a>
                            </div>
                            <div class="col-1">
                                <a href="events/edit/{{event.id}}" class="btn btn-light btn-sm btn-block"><i
                    class="fa fa-edit"></i>Edit</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <dl class="well list-detail">
                                            <dt>Event name</dt>
                                            <dd>{{event.eventName}}</dd>
                                            <dt>Start date</dt>
                                            <dd class="text-muted"><i class="fa fa-calendar"></i> {{event.startDate | date:'dd-MM-yyyy'}}</dd>
                                            <dt>End date</dt>
                                            <dd class="text-muted"><i class="fa fa-calendar"></i> {{event.endDate | date:'dd-MM-yyyy'}}</dd>
                                            <dt>Status</dt>
                                            <dd><span class="badge badge-success">{{event.status | eventStatus:event.startDate:event.endDate}}</span>
                                            </dd>
                                        </dl>
                                    </div>
                                    <div class="col">
                                        <dl class="list-detail">
                                            <dt>Pickup date</dt>
                                            <dd class="text-muted"><i class="fa fa-calendar"></i> {{event.pickUpDate | date:'dd-MM-yyyy'}}
                                            </dd>
                                            <dt>Pickup time</dt>
                                            <dd class="text-muted"><i class="fa fa-clock"></i> {{event.pickUpTime}}</dd>
                                            <dt>Return date</dt>
                                            <dd class="text-muted"><i class="fa fa-calendar"></i> {{event.returnDate | date:'dd-MM-yyyy'}}
                                            </dd>
                                            <dt>Return time</dt>
                                            <dd class="text-muted"><i class="fa fa-clock"></i> {{event.returnTime}}</dd>
                                        </dl>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col">
                                        <dl class="list-detail">
                                            <dt>Name</dt>
                                            <dd>{{event.clientUser.firstName}} {{event.clientUser.lastName}}</dd>
                                            <dt>E-Mail</dt>
                                            <dd><i class="fa fa-envelope"></i> {{event.clientUser.firstEmail}}</dd>
                                            <dt>Phone</dt>
                                            <dd><i class="fa fa-phone"></i> {{event.clientUser.firstPhone}}</dd>
                                            <dt>Status</dt>
                                            <dd><span class="badge badge-success">{{event.clientUser.status | clientStatus}}</span></dd>
                                            <dt>Registration</dt>
                                            <dd class="text-muted"><i class="fa fa-calendar"></i> {{event.clientUser.createdAt | date:'dd-MM-yyyy HH:mm'}}</dd>
                                        </dl>
                                    </div>
                                    <div class="col">
                                        <dl>
                                            <dt>Company Name</dt>
                                            <dd>{{event.clientUser.company.name}}</dd>
                                            <dt>E-Mail</dt>
                                            <dd><i class="fa fa-envelope"></i> {{event.clientUser.company.firstEmail}}</dd>
                                            <dt>Address</dt>
                                            <dd>{{event.clientUser.company.address}}</dd>
                                            <dt>City</dt>
                                            <dd>{{event.clientUser.company.city}}</dd>
                                            <dt>Postal Code</dt>
                                            <dd>{{event.clientUser.company.postalCode}}</dd>
                                        </dl>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <app-requested-hardware-software-table [event]="event"></app-requested-hardware-software-table>
            </div>
        </div>
    </div>
</div>
